import { Api } from 'src/common';
import { JOURNEY_NAME } from '../types/tealium-service';
import { Environment } from 'src/Environment';

type RequestBody = {
  message?: string;
  solutionType: string | undefined;
  currentStep: Step;
  logType?: LogType;
  traceId: string;
  referenceNumber?: string;
  journey?: string;
  timestamp: string;
  url?: string;
  stepName?: string;
  subStepName?: string;
  api?: API;
  environment: string;
  device: Device;
};

enum LogType {
  ERROR = 'error',
  INFO = 'info',
}

type API = {
  responseTime?: string;
  statusCode?: number;
  endpoint: string;
  requestBody?: Record<string, any>;
  responseBody?: Record<string, any>;
  params?: Record<string, any>;
};

type Device = {
  platform: string;
  browserName: string;
};

type Step = {
  stepName?: string;
  subStepName?: string;
};

export interface ILoggingService {
  info(body: RequestBody, updateIsRequired?: boolean): void;
  error(body: RequestBody): void;
}

export class LoggingService implements ILoggingService {
  private LOGGING_ENDPOINT = 'audits';
  private loggingIsDisabled: boolean;
  public journeyName: JOURNEY_NAME | undefined;

  constructor() {
    this.loggingIsDisabled = Environment.current.disabledFeatures.logging;
  }

  info(body: RequestBody, updateIsRequired?: boolean): void {
    const endpoint = updateIsRequired
      ? `${this.LOGGING_ENDPOINT}?updateIsRequired=true`
      : this.LOGGING_ENDPOINT;
    const logType: string = 'info';

    if (!this.loggingIsDisabled) {
      try {
        Api.post(`${Environment.current.apiHost}${Environment.current.newApiBase}${endpoint}`, {
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...body, logType }),
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  error(body: RequestBody): void {
    const logType: string = 'error';

    if (!this.loggingIsDisabled) {
      try {
        Api.post(
          `${Environment.current.apiHost}${Environment.current.newApiBase}${this.LOGGING_ENDPOINT}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...body, logType }),
          },
        );
      } catch (error) {
        console.error(error);
      }
    }
  }
}
